export const SUPPORT_REQUEST_START = "SUPPORT_REQUEST_START";
export const CREATE_SUPPORT_REQUEST = "CREATE_SUPPORT_REQUEST";
export const CREATE_SUPPORT_REQUEST_SUCCESS = "CREATE_SUPPORT_REQUEST_SUCCESS";
export const CREATE_SUPPORT_REQUEST_FAIL = "CREATE_SUPPORT_REQUEST_FAIL";
export const GET_SUPPORT_REQUESTS = "GET_SUPPORT_REQUESTS";
export const GET_SUPPOR_REQUESTS_SUCCESS = "GET_SUPPOR_REQUESTS_SUCCESS";
export const GET_SUPPORT_REQUESTS_FAIL = "GET_SUPPORT_REQUESTS_FAIL";
export const SUPPORT_REQUEST_LOADING = "SUPPORT_REQUEST_LOADING";
